module.exports = __webpack_public_path__ + "img/flip-to-front.8772d580.svg";